import api from "@/plugins/axios";

export const getAll = async () => {
  const response = await api.get("/indisponibilidad");
  return response.data;
};

export const getAllEmpresa = async (id) => {
  const params = {};
  params.id = id.value ?? null;
  const response = await api.get("/indisponibilidad", { params });
  return response.data;
};

export const getById = async (id) => {
  const response = await api.get(`/indisponibilidad/${id}`);
  return response.data;
};

export const getByEmpresaHorario = async (idEmpresa, idHorario) => {
  try {
    const response = await api.get(`/indisponibilidad/buscar`, {
      params: { idEmpresa, idHorario },
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    } else {
      throw error;
    }
  }
};

export const create = async (data) => {
  const response = await api.post("/indisponibilidad", data);
  return response.data;
};

export const update = async (id, data) => {
  const response = await api.put(`/indisponibilidad/${id}`, data);
  return response.data;
};

export const remove = async (id) => {
  await api.delete(`/indisponibilidad/${id}`);
};

export const restore = async (id) => {
  await api.delete(`/indisponibilidad/${id}`);
};
